export const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN?.trim() ||
  ''; // empty string => same-origin

export const ENV_LABEL = (() => {
  try {
    const normalize = (value) => {
      const s = String(value || '').trim();
      if (!s) return '';
      // Allow setting "[DEV]" but display "DEV" (common badge formatting).
      const match = s.match(/^\[(.*)\]$/);
      return String(match ? match[1] : s).trim();
    };

    const injected = typeof window !== 'undefined' ? normalize(window.__NEEDL_ENV_LABEL__) : '';
    if (injected) return injected;
    const host = typeof window !== 'undefined' ? String(window.location?.hostname || '').toLowerCase() : '';
    if (host.startsWith('dev.')) return 'DEV';
    return '';
  } catch {
    return '';
  }
})();

export function apiUrl(pathname) {
  if (!pathname.startsWith('/')) {
    throw new Error(`apiUrl expects a leading '/': got "${pathname}"`);
  }
  return `${API_ORIGIN}${pathname}`;
}








